import React, { useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { Grid, Typography } from '@mui/material';
import { makeStyles, Button } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import moment from 'moment';
import Modal from '../common/Modal';
import { ErrorToast, notifySuccess } from '../utils/Utils';
import { showProgress } from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';

const useStyle = makeStyles({
  popupContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  label: {
    fontSize: '12px',
    color: '#667085',
  },
  item: {
    color: '#10182B',
    fontSize: '14px',
  },
  divider: {
    height: '1px',
    background: '#D0D5DD',
    marginTop: '15px',
  },
  required_field: {
    fontSize: '14px',
    color: '#667085',
    marginBottom: '5px',
    '&:after': {
      content: "' *'",
      color: '#F50000',
    },
  },
});

export const EditAssignmentPopup = ({
  id,
  dealershipId,
  departmentRoleIds,
  isOpen,
  setIsOpen,
  startDate,
  endDate: eDate,
  dealerName,
  fetchTopicDealershipList,
}) => {
  const classes = useStyle();
  const dispatch = useDispatch();

  const [endDate, setEndDate] = useState(eDate);

  const topicOfTheMonthDate = useSelector((state) => state.getTopicOfTheMonth.selectedDate);
  const topicOfTheMonthSelectedId = useSelector((state) => state.getTopicOfTheMonth.selectedTopicId);
  const topicOfTheMonthSelectedData = useSelector((state) => state.getTopicOfTheMonth.selectedTopicData);

  // Get today's date
  const today = new Date();

  const handleEdit = async () => {
    dispatch(showProgress(true));
    const payload = {
      endDate: moment(endDate).format('YYYY-MM-DD'),
      ids: id,
      dealershipId,
      departmentRoleIds,
    };
    try {
      await service.post(apiEndpoints.TOM_EDIT_ASSIGNMENT, payload);
      notifySuccess('Assignment updated successfully');
      fetchTopicDealershipList(topicOfTheMonthSelectedId.toString(), topicOfTheMonthDate.date);
      setIsOpen(false);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const handleStartDateChange = (date) => {
    setEndDate(date);
  };
  return (
    <Modal isOpen={isOpen} height="65vh" width="500px">
      <Grid container className={classes.popupContainer}>
        <Grid item xs={12}>
          <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
            <Grid item>
              <Grid item style={{ fontWeight: '700', fontSize: '18px' }}>
                Edit Assignment
              </Grid>
            </Grid>
            <Grid item>
              <CloseIcon onClick={() => setIsOpen(false)} style={{ cursor: 'pointer' }} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid containe style={{ background: '#f3f4f7', height: '55vh', padding: '20px 10px' }}>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={12}>
                  <Typography className={classes.label}>Dealership</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography className={classes.item}>{dealerName}</Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container style={{ marginTop: '15px' }}>
                <Grid item xs={12}>
                  <Typography className={classes.label}>Topic:</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography className={classes.item}>{topicOfTheMonthSelectedData?.topicName}</Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container className={classes.divider}></Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container style={{ marginTop: '15px' }}>
                <Grid item xs={12}>
                  <Typography className={classes.required_field}>Start Date</Typography>
                </Grid>
                <Grid item xs={12}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      placeholder="YYYY-MM-DD"
                      value={startDate}
                      InputProps={{
                        disableUnderline: true,
                        readOnly: true,
                        classes: {
                          input: 'date-field',
                        },
                      }}
                      format="yyyy-MM-dd"
                      style={{
                        width: '95%',
                        backgroundColor: 'white',
                        height: '40px',
                        borderRadius: 8,
                        padding: '10px',
                      }}
                      disabled
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid container style={{ marginTop: '15px' }}>
                <Grid item xs={12}>
                  <Typography className={classes.required_field}>End Date</Typography>
                </Grid>
                <Grid item xs={12}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      placeholder="YYYY-MM-DD"
                      value={endDate}
                      onChange={handleStartDateChange}
                      InputProps={{
                        disableUnderline: true,
                        readOnly: true,
                        classes: {
                          input: 'date-field',
                        },
                      }}
                      format="yyyy-MM-dd"
                      style={{
                        width: '95%',
                        backgroundColor: 'white',
                        height: '40px',
                        borderRadius: 8,
                        padding: '10px',
                      }}
                      minDate={today}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container style={{ display: 'flex' }}>
            <Grid container direction="row" justifyContent="flex-end" alignItems="center">
              <>
                <Button onClick={() => setIsOpen(false)} variant="outlined">
                  Cancel
                </Button>
                <Button variant="contained" color="primary" style={{ marginLeft: '10px' }} onClick={handleEdit}>
                  Save
                </Button>
              </>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};
